import React, { useState, useEffect } from 'react';
import dateFormat from 'dateformat';
import SearchByTwoStationsForm from '../components/SearchByTwoStationsForm';
import SearchByTrainNumberForm from '../components/SearchByTrainNumberForm';
import SearchByOneStationForm from '../components/SearchByOneStationForm';
import TrainsTable from '../components/TrainsTable';
import trainTypes from '../TrainTypes';

export function Home() {
	const [stationList, setStationList] = useState([]);
	const [trainList, setTrainList] = useState([]);

	const [searchByTwoStationsDate, setSearchByTwoStationsDate] = useState(new Date());
	const [searchByTrainNumberDate, setSearchByTrainNumberDate] = useState(new Date());
	const [searchByOneStationDate, setSearchByOneStationDate] = useState(new Date());

	const [searchByTwoStationFirstStationId, setSearchByTwoStationFirstStationId] = useState();
	const [searchByTwoStationSecondStationId, setSearchByTwoStationSecondStationId] = useState();
	const [searchByOneStationStationId, setSearchByOneStationStationId] = useState();

	const [searchByTrainNumberValue, setSearchByTrainNumberValue] = useState();

	const [foundTrains, setFoundTrains] = useState([]);
	const [selectedDate, setSelectedDate] = useState(new Date());

	const setFoundTrainsAndMap = (data) => {
		setFoundTrains(data.map(x => ({
			...x,
			trainType: trainTypes[x.trainType]
		})));
	};

	const setTrainsToday = () => {
		const today = new Date();
		fetch(`/api/GetTrainListByDate?departureDate=${dateFormat(today, "dd-mm-yyyy")}`)
			.then(x => x.json())
			.then(data => {
				setTrainList(data);
				setFoundTrainsAndMap(data);
				setSelectedDate(today);
			})
			.catch(e => alert(e));
	};

	useEffect(() => {
		fetch("/api/GetStationList")
			.then(x => x.json())
			.then(data => setStationList(data))
			.catch(e => alert(e));
		setTrainsToday();
	}, []);


	const searchByTwoStations = () => {
		fetch(`/api/GetTrainsBetweenTwoStations?stationFromId=${searchByTwoStationFirstStationId}
				&stationToId=${searchByTwoStationSecondStationId}
				&departureDate=${dateFormat(searchByTwoStationsDate, "dd-mm-yyyy")}`)
			.then(x => x.json())
			.then(data => {
				setFoundTrainsAndMap(data);
				setSelectedDate(searchByTwoStationsDate);
			})
			.catch(e => alert(e));
	};

	const searchByTrainNumber = () => {
		fetch(`/api/GetTrainListByNumber?trainNumber=${searchByTrainNumberValue}
				&departureDate=${dateFormat(searchByTrainNumberDate, "dd-mm-yyyy")}`)
			.then(x => x.json())
			.then(data => {
				setFoundTrainsAndMap(data);
				setSelectedDate(searchByTrainNumberDate);
			})
			.catch(e => alert(e));
	}

	const searchByOneStation = () => {
		fetch(`/api/GetTrainListByStation?stationId=${searchByOneStationStationId}
				&departureDate=${dateFormat(searchByOneStationDate, "dd-mm-yyyy")}`)
			.then(x => x.json())
			.then(data => {
				setFoundTrainsAndMap(data);
				setSelectedDate(searchByOneStationDate);
			})
			.catch(e => alert(e));
	}
	const stationListOptions = stationList.map(x => ({ value: x.id, label: x.name }));
	const trainListOptions = trainList.map(x => ({ value: x.number, label: x.number }));
	const returnButton = <a href="http://www.expresspk.ru/" className={"return-link"}>Назад</a>;
	return (
		<div>
			{returnButton}
			<div className={"search-block"}>
				<SearchByTwoStationsForm
					stations={stationListOptions}
					setFirstStation={setSearchByTwoStationFirstStationId}
					setSecondStation={setSearchByTwoStationSecondStationId}
					setDate={setSearchByTwoStationsDate}
					date={searchByTwoStationsDate}
					search={searchByTwoStations}
					onClear={setTrainsToday}
				/>
				<SearchByTrainNumberForm
					trains={trainListOptions}
					setTrainNumber={setSearchByTrainNumberValue}
					setDate={setSearchByTrainNumberDate}
					date={searchByTrainNumberDate}
					search={searchByTrainNumber}
					onClear={setTrainsToday}
				/>
				<SearchByOneStationForm
					stations={stationListOptions}
					setStation={setSearchByOneStationStationId}
					setDate={setSearchByOneStationDate}
					date={searchByOneStationDate}
					search={searchByOneStation}
					onClear={setTrainsToday}
				/>
			</div>
			<div className="info">
				<p className="info__text">На <span className="info__date">{dateFormat(selectedDate, "dd.mm.yyyy")}</span> г. найдено <span className="info__trains">{foundTrains.length}</span> поездов.</p>
				<h1 className="info__warning">Время отправления и прибытия местное</h1>
			</div>
			<TrainsTable data={foundTrains} selectedDate={selectedDate}/>
		</div>
	);
}